import { render, staticRenderFns } from "./BoostPlansMenu.vue?vue&type=template&id=c46f2ac0&scoped=true"
import script from "./BoostPlansMenu.vue?vue&type=script&lang=js"
export * from "./BoostPlansMenu.vue?vue&type=script&lang=js"
import style0 from "./BoostPlansMenu.vue?vue&type=style&index=0&id=c46f2ac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46f2ac0",
  null
  
)

export default component.exports